'use client';
import React, { useState, useEffect } from 'react';
import AppLogo from '@/components/ui/AppLogo';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { label: 'Diagnostics', href: '#diagnostics' },
    { label: 'Resources', href: '#resources' },
    { label: 'Refer', href: '#refer' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${
        scrolled ? 'nav-glass py-3' : 'py-5'
      }`}
      style={!scrolled ? { background: 'transparent' } : {}}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
        {/* Logo */}
        <a href="#" className="flex items-center gap-3 group" aria-label="Hemato home">
          <AppLogo
            text="Hemato"
            iconName="BeakerIcon"
            size={32}
            className="text-[#F4F7FA]"
          />
        </a>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-10">
          {navLinks?.map((link) => (
            <a
              key={link?.href}
              href={link?.href}
              className="text-sm font-medium tracking-wide transition-colors duration-200"
              style={{ color: 'rgba(244,247,250,0.7)' }}
              onMouseEnter={(e) => (e.currentTarget.style.color = '#F4F7FA')}
              onMouseLeave={(e) => (e.currentTarget.style.color = 'rgba(244,247,250,0.7)')}
            >
              {link?.label}
            </a>
          ))}
        </div>

        {/* CTA */}
        <div className="hidden md:flex items-center gap-4">
          <a
            href="#resources"
            className="btn-rose px-6 py-2.5 rounded-full text-sm font-semibold tracking-wide"
          >
            Download Workup Guide
          </a>
        </div>

        {/* Mobile toggle */}
        <button
          className="md:hidden p-2 rounded-lg"
          style={{ color: '#F4F7FA' }}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle navigation"
        >
          <svg width="22" height="16" viewBox="0 0 22 16" fill="none">
            {menuOpen ? (
              <path d="M1 1L21 15M21 1L1 15" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
            ) : (
              <>
                <path d="M1 1H21" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
                <path d="M1 8H21" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
                <path d="M1 15H21" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
              </>
            )}
          </svg>
        </button>
      </div>
      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden nav-glass mt-2 mx-4 rounded-2xl p-6 flex flex-col gap-4">
          {navLinks?.map((link) => (
            <a
              key={link?.href}
              href={link?.href}
              className="text-sm font-medium py-2"
              style={{ color: 'rgba(244,247,250,0.85)' }}
              onClick={() => setMenuOpen(false)}
            >
              {link?.label}
            </a>
          ))}
          <a
            href="#resources"
            className="btn-rose px-6 py-3 rounded-full text-sm font-semibold text-center mt-2"
            onClick={() => setMenuOpen(false)}
          >
            Download Workup Guide
          </a>
        </div>
      )}
    </nav>
  );
}